module.exports = __webpack_public_path__ + "static/playgroup-2@2x-a5d1949c7bfe26045d7af52d7c9f8f6d.jpg";